import { z } from 'zod'

export const dumpObjectSchema = z.object({
  key: z.string(),
  databaseName: z.string(),
  size: z.number().int().nonnegative(),
  lastModified: z.string(),
})
export type DumpObject = z.infer<typeof dumpObjectSchema>

export const dumpsQuerySchema = z.object({
  database: z.string().min(1),
})
export type DumpsQuery = z.infer<typeof dumpsQuerySchema>

export const dumpsResponseSchema = z.object({
  databaseName: z.string(),
  dumps: z.array(dumpObjectSchema),
})
export type DumpsResponse = z.infer<typeof dumpsResponseSchema>

export const dumpUrlQuerySchema = z.object({
  key: z.string().min(1),
})
export type DumpUrlQuery = z.infer<typeof dumpUrlQuerySchema>

export const dumpUrlResponseSchema = z.object({
  url: z.string().url(),
  expiresAt: z.string(),
})
export type DumpUrlResponse = z.infer<typeof dumpUrlResponseSchema>
